import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeltaBusinessService } from 'src/app/shared/services/delta-business.service';
import { DocumentManagerService } from './../../../services/document-manager.service';

@Component({
    selector: 'app-share-via-email-dialog',
    templateUrl: './share-via-email-dialog.component.html',
    styleUrls: ['./share-via-email-dialog.component.css']
})
export class ShareViaEmailDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ShareViaEmailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private deltaBusinessService: DeltaBusinessService,
        private documentService: DocumentManagerService
    ) {}
    email = '';
    send() {
        const payload = {
            Purpose: 'DMSShareViaEmail',
            Language: 'en-US',
            Subject: {
                DocumentName: this.data.Name
            },
            DataContext: {
                Sender: this.documentService.loggedIuUser.DisplayName
            },
            To: [this.email.trim()],
            Attachments: [this.data.FileStorageId]
        };
        this.deltaBusinessService
            .sendEnqueMail(payload)
            .subscribe((resp: any) => {
                if (resp && resp.body && resp.body.StatusCode === 0) {
                    this.dialogRef.close({ success: true });
                } else {
                    this.dialogRef.close({ fail: true });
                }
            });
    }
}
